import {useQuery} from 'react-query'
import {ReservationEditModalForm} from './ReservationEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_dashboard/helpers'
import {useListView} from '../core/ListViewProvider'
import { getOneById } from '../../../../services/common_requests'
import { initialReservation } from '../core/_models'

const ReservationEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: hotel,
    error,
  } = useQuery(
    `${QUERIES.RESERVATIONS_LIST}-reservation-${itemIdForUpdate}`,
    () => {
      return getOneById(itemIdForUpdate,"/reservations")
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <ReservationEditModalForm isReservationLoading={isLoading} hotel={{...initialReservation, _id: undefined}} />
  }

  if (!isLoading && !error && hotel) {
    return <ReservationEditModalForm isReservationLoading={isLoading} hotel={hotel} />
  }

  return null
}

export {ReservationEditModalFormWrapper}
